import { analytics, usePlaybackStateStore } from '@annunciate/core';
import { pausePlayers } from './onPause';
export const onStop = async () => {
    await pausePlayers();
    const content = usePlaybackStateStore.getState().content;
    if (content) {
        await analytics.emitContentEvent("pausing", { content });
        await analytics.emitPlaybackEvent("exited");
        usePlaybackStateStore.setState({
            content: undefined,
            initialPosition: undefined,
            sleepTime: undefined,
        });
    }
};
//# sourceMappingURL=onStop.js.map